import { CognitoChangeRequestFrom } from './cognito-change-request-from';
import { CognitoChangeRequestTo } from './cognito-change-request-to';

export class AccountManagement {
    constructor (
        public LoginRequestChangeFrom: CognitoChangeRequestFrom[] = [],
        public HasRequestFrom: boolean = false,
        public LoginRequestChangeTo: CognitoChangeRequestTo[] = [],
        public HasRequestTo: boolean = false,
    ) { }
}
